import { SourceOfBusiness } from '../../api/models';
import {
  createAction,
  createActionWithPayload,
  IAction,
  IActionWithPayload,
} from '../utils';

const ACTION_LOAD_BUSINESS_SOURCE_REQUEST =
  'ENTITIES/LOAD_BUSINESS_SOURCE_REQUEST';
const ACTION_LOAD_BUSINESS_SOURCE_SUCCESS =
  'INTENT/LOAD_BUSINESS_SOURCE_SUCCESS';
const ACTION_LOAD_BUSINESS_SOURCE_ERROR = 'INTENT/LOAD_BUSINESS_SOURCE_ERROR';

export interface SourceOfBusinessState {
  sourceOfBusiness: SourceOfBusiness[];
  isLoading?: boolean;
  isLoaded?: boolean;
}

const initialState: SourceOfBusinessState = {
  sourceOfBusiness: [],
  isLoaded: false,
  isLoading: false,
};

type SourceOfBusinessRequestActionType = IAction<
  typeof ACTION_LOAD_BUSINESS_SOURCE_REQUEST
>;

type SourceOfBusinessSuccessActionType = IActionWithPayload<
  typeof ACTION_LOAD_BUSINESS_SOURCE_SUCCESS,
  SourceOfBusiness[]
>;

type SourceOfBusinessErrorActionType = IAction<
  typeof ACTION_LOAD_BUSINESS_SOURCE_ERROR
>;

type Actions =
  | SourceOfBusinessRequestActionType
  | SourceOfBusinessSuccessActionType
  | SourceOfBusinessErrorActionType;

export const loadSourceOfBusinessRequestAction = (): SourceOfBusinessRequestActionType => {
  return createAction(ACTION_LOAD_BUSINESS_SOURCE_REQUEST);
};

export const loadSourceOfBusinessSuccessAction = (
  data: SourceOfBusiness[]
): SourceOfBusinessSuccessActionType => {
  return createActionWithPayload(ACTION_LOAD_BUSINESS_SOURCE_SUCCESS, data);
};

export const loadSourceOfBusinessErrorAction = (): SourceOfBusinessErrorActionType => {
  return createAction(ACTION_LOAD_BUSINESS_SOURCE_ERROR);
};

// reducer
export const sourceOfBusinessReducer = (
  state: SourceOfBusinessState = initialState,
  action: Actions
): SourceOfBusinessState => {
  switch (action.type) {
    case ACTION_LOAD_BUSINESS_SOURCE_REQUEST:
      return {
        ...state,
        isLoading: true,
        isLoaded: false,
      };
    case ACTION_LOAD_BUSINESS_SOURCE_ERROR:
      return {
        ...state,
        isLoaded: true,
        isLoading: false,
      };
    case ACTION_LOAD_BUSINESS_SOURCE_SUCCESS:
      return {
        ...state,
        sourceOfBusiness: action.payload,
        isLoading: false,
        isLoaded: true,
      };
    default:
      return state;
  }
};
